import { render, staticRenderFns } from "./CaptureDriversLicenseBack.vue?vue&type=template&id=684eb246&"
import script from "./CaptureDriversLicenseBack.vue?vue&type=script&lang=ts&"
export * from "./CaptureDriversLicenseBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports